import { callbackService } from './callback-service';
import { Application, ClientInfo } from './constants/application';
import { MessageType } from './constants/message-type';
import { LOGGER } from './logger';
import { Message } from './models/message';

class MessageService {
  private static messageId: number = 0;

  constructor() {
    this.registerMessageListener();
  }

  public getNextMessageId(): string {
    return ClientInfo.ID + '-' + (++MessageService.messageId);
  }

  public sendMessage(msg: Message) {
    /**
     * The Message object can´t be serialized by the postMessage method if it has functions
     * https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Structured_clone_algorithm
     */
    msg.portalId = ClientInfo.PORTAL_ID;
    msg = JSON.parse(JSON.stringify(msg)); // Functions cleaning
    window.parent.postMessage(msg, ClientInfo.PARENT_ORIGIN);
    const mtype = msg.id ? msg.type + '[' + msg.id + ']' : msg.type;
    LOGGER.debug('Sent \'' + mtype + '\' to [' + msg.destination + ']: ' + JSON.stringify(msg.message));
  };

  private registerMessageListener() {
    LOGGER.debug('Portal message listener added...');
    window.addEventListener('message', event => {
      const msg: Message = event?.data;
      if (msg) {
        if (ClientInfo.ID && msg.destination === ClientInfo.ID) {
          const mtype = msg.id ? msg.type + '[' + msg.id + ']' : msg.type;
          LOGGER.debug('Received \'' + mtype + '\' from [' + msg.source + ']: ' + JSON.stringify(msg.message));
          if (this.isAcknowledgable(msg.type)) {
            this.sendMessage(new Message(this.getNextMessageId(), MessageType._auto_ack, ClientInfo.ID, Application.PORTAL, msg));
          }
          callbackService.callMessageHandler(msg);
        }
      }
    });
  }

  public isAcknowledgable(messageType: MessageType) {
    return (MessageType.userStateChange === messageType || MessageType.tenantChange === messageType);
  }
}

export const messageService = new MessageService();
